'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _createRef = require('./createRef');

var _createRef2 = _interopRequireDefault(_createRef);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ForwardRefPolyfill = function (_React$Component) {
  _inherits(ForwardRefPolyfill, _React$Component);

  function ForwardRefPolyfill(props) {
    _classCallCheck(this, ForwardRefPolyfill);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.__forwardedRef = (0, _createRef2.default)();
    return _this;
  }

  ForwardRefPolyfill.prototype.__render = function __render() {
    return null;
  };

  ForwardRefPolyfill.prototype.getRef = function getRef() {
    // Check for `.current` first before `.value` since it's the
    // newest property name in React.
    return this.__forwardedRef.current || this.__forwardedRef.value;
  };

  ForwardRefPolyfill.prototype.render = function render() {
    return this.__render(this.props, this.__forwardedRef);
  };

  return ForwardRefPolyfill;
}(_react2.default.Component);

ForwardRefPolyfill.displayName = 'ForwardRefPolyfill';
exports.default = ForwardRefPolyfill;
module.exports = exports['default'];